var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface69473100"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.039216%,80.000001%,44.313726%)",
      fillOpacity: 1
    },
    d: "M 28.796875 6.136719 C 28.605469 6.136719 28.417969 6.191406 28.257812 6.292969 C 22.175781 10.089844 17.1875 15.183594 13.027344 21.21875 C 10.925781 18.332031 8.582031 15.8125 5.714844 14.136719 C 5.40625 13.941406 5.015625 13.933594 4.699219 14.109375 C 4.378906 14.289062 4.183594 14.625 4.183594 14.988281 C 4.1875 15.355469 4.386719 15.691406 4.707031 15.863281 C 7.597656 17.550781 10.050781 20.1875 12.242188 23.421875 C 12.433594 23.695312 12.746094 23.859375 13.078125 23.859375 C 13.410156 23.855469 13.722656 23.6875 13.90625 23.410156 C 18.082031 17.074219 23.132812 11.847656 29.316406 7.992188 C 29.699219 7.757812 29.882812 7.296875 29.761719 6.863281 C 29.640625 6.433594 29.246094 6.132812 28.796875 6.136719 Z M 28.796875 6.136719 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.c3a509200a19d24e53b56ec93f96190c.svg";
export { ForwardRef as ReactComponent };